export type FioParts = {
  last_name: string;
  first_name: string;
  patronymic: string;
};

export const EMPTY_FIO: FioParts = {
  last_name: "",
  first_name: "",
  patronymic: "",
};
